import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AlertsProvider } from './contexts/AlertsContext';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider } from './contexts/AuthContext';

import Home from './pages/Home';
import Helpers from './pages/Helpers';
import Properties from './pages/Properties';
import About from './pages/About';
import Contact from './pages/Contact';
import Account from './pages/Account';
import AccountProfile from './pages/account/ProfilePage';
import AccountSecurity from './pages/account/SecurityPage';
import AccountBilling from './pages/account/BillingPage';
import AccountNotifications from './pages/account/NotificationsPage';
import Header from './components/Header';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import ChiefRoute from './components/ChiefRoute';
import Alerts from './pages/Alerts';
import AdminPortal from './pages/AdminPortal';
import SetupDepartment from './pages/SetupDepartment';
import JoinDepartment from './pages/JoinDepartment';
import DepartmentDetail from './pages/DepartmentDetail';
import CreateAlert from './pages/CreateAlert';
import EditAlert from './pages/EditAlert';
import Login from './pages/Login';
import CreateAccount from './pages/CreateAccount';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import FAQ from './pages/FAQ';
import IRMap from './pages/IRMap';
import SetupRancher from './pages/SetupRancher';
import SetupHelper from './pages/SetupHelper';
import PropertyFeatures from './pages/PropertyFeatures';
import EditProperty from './pages/EditProperty';
import EditPropertyFeatures from './pages/EditPropertyFeatures';
import PropertyDetail from './pages/PropertyDetail';
import AlertDetail from './pages/AlertDetail';
import AlertsLog from './pages/AlertsLog';
import DepartmentAlertLog from './pages/DepartmentAlertLog';
import IncidentMap from './pages/IncidentMap';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AlertsProvider>
          <Router>
            <div className="app">
              <Header />
              <main className="main-content">
                <Routes>
                  {/* ── Public routes ─────────────────────────────────── */}
                  <Route path="/" element={<Home />} />
                  <Route path="/helpers" element={<Helpers />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/create-account" element={<CreateAccount />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/faq" element={<FAQ />} />

                  {/* ── Protected routes ──────────────────────────────── */}
                  <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                  <Route path="/properties" element={<PrivateRoute><SetupRancher /></PrivateRoute>} />
                  <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>}>
                    <Route index element={<AccountProfile />} />
                    <Route path="profile" element={<AccountProfile />} />
                    <Route path="security" element={<AccountSecurity />} />
                    <Route path="billing" element={<AccountBilling />} />
                    <Route path="notifications" element={<AccountNotifications />} />
                  </Route>
                  <Route path="/alerts" element={<PrivateRoute><Alerts /></PrivateRoute>} />
                  <Route path="/alerts/:id" element={<PrivateRoute><AlertDetail /></PrivateRoute>} />
                  <Route path="/alerts/:id/edit" element={<PrivateRoute><EditAlert /></PrivateRoute>} />
                  <Route path="/alerts/:id/incident-map" element={<PrivateRoute><IncidentMap /></PrivateRoute>} />
                  <Route path="/alerts-log" element={<PrivateRoute><AlertsLog /></PrivateRoute>} />
                  <Route path="/alerts-department-log" element={<ChiefRoute><DepartmentAlertLog /></ChiefRoute>} />
                  <Route path="/create-alert" element={<PrivateRoute><CreateAlert /></PrivateRoute>} />
                  <Route path="/irmap" element={<PrivateRoute><IRMap /></PrivateRoute>} />
                  <Route path="/setup/rancher" element={<PrivateRoute><SetupRancher /></PrivateRoute>} />
                  <Route path="/setup/rancher/features" element={<PrivateRoute><PropertyFeatures /></PrivateRoute>} />
                  <Route path="/setup/helper" element={<PrivateRoute><SetupHelper /></PrivateRoute>} />
                  <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                  <Route path="/setup/department" element={<ChiefRoute><SetupDepartment /></ChiefRoute>} />
                  <Route path="/join-department" element={<PrivateRoute><JoinDepartment /></PrivateRoute>} />
                  <Route path="/departments/:id" element={<PrivateRoute><DepartmentDetail /></PrivateRoute>} />
                  <Route path="/admin" element={<AdminRoute><AdminPortal /></AdminRoute>} />
                  <Route path="/properties/:id" element={<PrivateRoute><PropertyDetail /></PrivateRoute>} />
                  <Route path="/property/:id/edit" element={<PrivateRoute><EditProperty /></PrivateRoute>} />
                  <Route path="/property/:id/edit/features" element={<PrivateRoute><EditPropertyFeatures /></PrivateRoute>} />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </AlertsProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
